import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import widthMixin from 'styles/utils/widthMixin';

const flexBox = (props) => {
  if (props && props.view) {
    return css`
      ${widthMixin} min-height: 16px;
      text-align: ${(props) => (props.alignLabel ? props.alignLabel : 'right')};
      text-transform: ${(props) => (props.uppercaseLabel ? props.uppercaseLabel : 'uppercase')};
      align-self: flex-start;
    `;
  }
  return css`
    align-self: flex-start;
    ${widthMixin} min-height: 34px;
    text-align: ${(props) => (props.alignLabel ? props.alignLabel : 'left')};
  `;
};

const fixedWidth = () => {
  return css`
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 30%;
    min-height: 34px;
  `;
};

const LabelBlock = styled.div`
  ${(props) => (props.flexBox ? flexBox(props) : fixedWidth())};
`;

LabelBlock.propTypes = {
  children: PropTypes.element.isRequired,
  flexBox: PropTypes.bool,
  cols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
LabelBlock.defaultProps = {
  flexBox: true,
  cols: 1 / 4,
};

export default LabelBlock;
